// extracted by mini-css-extract-plugin
export default {"cell":"CellComponent_cell__I8104","over":"CellComponent_over__u3+Db","grabble":"CellComponent_grabble__F+HBf"};